/**
 * divTopBar element
 * @returns {JQuery} $divTopBar
 */
export const $divTopBar = () => jQuery('#divTopBar');

/**
 * divContentHidden element
 * @returns {JQuery} $divContentHidden
 */
export const $divContentHidden = () => jQuery('#divContentHidden');
/**
 * gfLeftSideBar element
 * @returns {JQuery} $gfLeftSideBar
 */
export const $gfLeftSideBar = () => jQuery('#gfLeftSideBar');
/**
 * gfFrame element
 * @returns {JQuery} $gfFrame
 */
export const $gfFrame = () => jQuery('#gfFrame');
/**
 * gryffEditor element
 * @returns {JQuery} $gryffEditor
 */
export const $gryffEditor = () => $gfFrame().contents().find('.gryffeditor').first();
/**
 * gryffBody element
 * @returns {JQuery} $gryffBody
 */
export const $gryffBody = () => $gfFrame().contents().find('body').first();
export const $jQuery = jQuery;
